import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import ProjectPicker, { type ProjectPickerProps } from './view/index.tsx';

export default ComponentWithAnalytics('ProjectPicker', {
	onChange: 'changed',
})(ProjectPicker);

// eslint-disable-next-line jira/export/restrict-types-re-export
export type Props = ProjectPickerProps;
